export default __webpack_public_path__ + "static/media/lovariables.129adb4e.jpg";